'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeBundleDiscount } from '@/lib/api/productCatalog/types';

export default function useBundleDiscount(bundleDiscountUuid?: string) {
  const uri = `${API_URLS.PRODUCT_CATALOG_PROXY}/bundle_discounts/${bundleDiscountUuid}`;
  const shouldFetch = !!bundleDiscountUuid;

  const {
    data: bundleDiscountData,
    isLoading: bundleDiscountLoading,
    error: bundleDiscountError,
    mutate: mutateBundleDiscount,
  } = useSWR<TypeBundleDiscount, Error>(
    shouldFetch ? uri : null,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    bundleDiscountData,
    bundleDiscountLoading,
    bundleDiscountError,
    mutateBundleDiscount,
  };
}
